export default {
  data() {
    return {
      countdown: 0,
      countdownId: null
    };
  },
  created() {
    this.countdownId = setInterval(async () => {
      if (this.countdown === 1) {
        if (this.countdownFinalFunction) {
          await this.countdownFinalFunction();
        }
      }
      this.countdown && this.countdown--;
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.countdownId);
  }
};
